// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__Dsdpp","footer":"ModalCreateQualiphyProcedure_footer__1BcIs","additionData":"ModalCreateQualiphyProcedure_additionData__3EYmJ"};